// // ResumeBuilder.js
// import React, { useState, useRef } from 'react';
// import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas';
// import { saveAs } from 'file-saver';
// import './resumepage.css';

// const ResumeBuilder = () => {
//   // Form state
//   const [formData, setFormData] = useState({
//     name: '',
//     location: '',
//     phone: '',
//     email: '',
//     jobTitle: '',
//     jobDescription: '',
//     education: [{
//       degree: '',
//       institution: '',
//       location: '',
//       year: ''
//     }],
//     experience: [{
//       title: '',
//       company: '',
//       location: '',
//       duration: '',
//       achievements: ['', '', '']
//     }],
//     skills: ['', '', '', '', '', '', '', ''],
//     languages: [{
//       name: '',
//       level: ''
//     }]
//   });

//   // Resume states
//   const [generatedResume, setGeneratedResume] = useState(null);
//   const [resumeText, setResumeText] = useState('');
//   const [atsScore, setAtsScore] = useState(null);
//   const [matchedKeywords, setMatchedKeywords] = useState([]);
//   const [missedKeywords, setMissedKeywords] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState('modern');
//   const [isOptimizing, setIsOptimizing] = useState(false);
//   const [optimizationSuggestions, setOptimizationSuggestions] = useState(null);
//   const resumeRef = useRef(null);

//   // Handle form input changes
//   const handleInputChange = (e, section, index, subField) => {
//     const { name, value } = e.target;
    
//     if (section) {
//       if (subField) {
//         // For nested arrays like experience.achievements
//         setFormData(prev => {
//           const newData = {...prev};
//           newData[section][index][subField][parseInt(name)] = value;
//           return newData;
//         });
//       } else {
//         // For arrays like education, experience
//         setFormData(prev => {
//           const newData = {...prev};
//           newData[section][index][name] = value;
//           return newData;
//         });
//       }
//     } else {
//       // For simple fields
//       setFormData(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     }
//   };

//   // Add more items to arrays
//   const addItem = (section) => {
//     if (section === 'education') {
//       setFormData(prev => ({
//         ...prev,
//         education: [...prev.education, { degree: '', institution: '', location: '', year: '' }]
//       }));
//     } else if (section === 'experience') {
//       setFormData(prev => ({
//         ...prev,
//         experience: [...prev.experience, { title: '', company: '', location: '', duration: '', achievements: ['', '', ''] }]
//       }));
//     } else if (section === 'languages') {
//       setFormData(prev => ({
//         ...prev,
//         languages: [...prev.languages, { name: '', level: '' }]
//       }));
//     }
//   };

//   // Remove items from arrays
//   const removeItem = (section, index) => {
//     setFormData(prev => {
//       const newData = {...prev};
//       newData[section].splice(index, 1);
//       return newData;
//     });
//   };

//   // Generate professional summary based on job description and title
//   const generateProfessionalSummary = () => {
//     const { jobTitle, jobDescription } = formData;
    
//     if (!jobTitle || !jobDescription) {
//       alert("Please provide job title and description to generate a summary");
//       return;
//     }
    
//     // Algorithm to extract key requirements from job description
//     const keywords = extractKeywords(jobDescription);
//     const yearsExp = extractYearsOfExperience(jobDescription) || '5';
    
//     // Generate professional summary
//     const summary = `Customer-focused ${jobTitle} professional with solid understanding of ${keywords.slice(0, 3).join(', ')} and ${keywords.slice(3, 5).join(', ')}. Offering ${yearsExp} years of experience providing quality solutions and exceeding expectations. Demonstrated record of achieving targets by leveraging ${keywords.slice(5, 7).join(' and ')} skills.`;
    
//     // Update state
//     setGeneratedResume(prev => ({
//       ...prev,
//       summary
//     }));
//   };

//   // Extract keywords from job description
//   const extractKeywords = (text) => {
//     // Simple keyword extraction algorithm
//     const commonSkills = [
//       'communication', 'teamwork', 'leadership', 'customer service', 
//       'sales', 'marketing', 'analysis', 'research', 'development',
//       'programming', 'project management', 'retail', 'financial',
//       'accounting', 'reporting', 'presentation', 'negotiation',
//       'product knowledge', 'merchandising', 'inventory'
//     ];
    
//     const foundSkills = [];
//     commonSkills.forEach(skill => {
//       if (text.toLowerCase().includes(skill.toLowerCase())) {
//         foundSkills.push(skill);
//       }
//     });
    
//     // If we don't find enough skills, add some generic ones
//     while (foundSkills.length < 7) {
//       const remainingSkills = commonSkills.filter(s => !foundSkills.includes(s));
//       if (remainingSkills.length === 0) break;
//       foundSkills.push(remainingSkills[0]);
//     }
    
//     return foundSkills;
//   };

//   // Extract years of experience from job description
//   const extractYearsOfExperience = (text) => {
//     const match = text.match(/(\d+)[\s-]*years?[\s]*(?:of)?[\s]*experience/i);
//     return match ? match[1] : null;
//   };

//   // Generate resume based on form data and job description
//   const generateResume = () => {
//     const { name, location, phone, email, jobTitle, jobDescription } = formData;
    
//     if (!name || !jobTitle || !jobDescription) {
//       alert("Please fill out the required fields");
//       return;
//     }
    
//     // Extract skills from job description to enhance the resume
//     const jobKeywords = extractKeywords(jobDescription);
    
//     // Generate a professional summary
//     const summary = `Customer-focused ${jobTitle} professional with solid understanding of ${jobKeywords.slice(0, 2).join(' and ')}. Offering ${extractYearsOfExperience(jobDescription) || '5'} years of experience providing quality solutions and exceeding expectations. Demonstrated record of achieving targets by leveraging ${jobKeywords.slice(2, 4).join(' and ')} skills.`;
    
//     setGeneratedResume({
//       ...formData,
//       summary
//     });
//   };

//   // Calculate ATS score
//   const calculateATSScore = () => {
//     const { jobDescription } = formData;
//     if (!jobDescription || !resumeText) {
//       alert("Please provide both job description and resume text");
//       return;
//     }
    
//     // Extract important keywords from job description
//     const jdWords = jobDescription.toLowerCase().match(/\w+/g) || [];
//     const resumeWords = resumeText.toLowerCase().match(/\w+/g) || [];
    
//     // Create a set of unique job description words
//     const jdSet = new Set(jdWords);
    
//     // Find matches and calculate score
//     let matchCount = 0;
//     const matched = new Set();
//     const missed = new Set();
    
//     // Count matches
//     resumeWords.forEach(word => {
//       if (jdSet.has(word) && word.length > 3) { // Only count meaningful words
//         matchCount++;
//         matched.add(word);
//       }
//     });
    
//     // Find missed keywords
//     jdWords.forEach(word => {
//       if (!resumeWords.includes(word) && word.length > 3) {
//         missed.add(word);
//       }
//     });
    
//     // Calculate score (weighted by importance)
//     const baseScore = ((matchCount / (jdSet.size || 1)) * 100).toFixed(1);
//     // Add bonus for having exact job title
//     const titleBonus = resumeText.toLowerCase().includes(formData.jobTitle.toLowerCase()) ? 5 : 0;
    
//     const finalScore = Math.min(100, Number(baseScore) + titleBonus);
    
//     setAtsScore(finalScore);
//     setMatchedKeywords(Array.from(matched));
//     setMissedKeywords(Array.from(missed).slice(0, 10)); // Show top 10 missed keywords
//   };

//   // Optimize resume based on job description
//   const optimizeResume = () => {
//     setIsOptimizing(true);
    
//     // Simulating ML-based analysis with a timeout
//     setTimeout(() => {
//       const { jobDescription } = formData;
//       const keywords = extractKeywords(jobDescription);
      
//       // Generate optimization suggestions
//       const suggestions = {
//         addKeywords: keywords.filter(k => !resumeText.toLowerCase().includes(k.toLowerCase())),
//         improveSummary: `Consider highlighting your experience with ${keywords.slice(0, 3).join(', ')} in your summary.`,
//         formatImprovements: [
//           "Use bullet points for achievements to improve readability",
//           "Quantify your achievements with numbers where possible",
//           "Ensure consistent tense throughout resume"
//         ]
//       };
      
//       setOptimizationSuggestions(suggestions);
//       setIsOptimizing(false);
//     }, 1500);
//   };

//   // Download resume as PDF
//   const downloadPDF = () => {
//     if (!resumeRef.current) return;
    
//     html2canvas(resumeRef.current).then(canvas => {
//       const imgData = canvas.toDataURL('image/png');
//       const pdf = new jsPDF({
//         orientation: 'portrait',
//         unit: 'mm',
//         format: 'a4'
//       });
      
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = pdf.internal.pageSize.getHeight();
//       const ratio = canvas.width / canvas.height;
//       const imgWidth = pdfWidth;
//       const imgHeight = pdfWidth / ratio;
      
//       pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
//       pdf.save(`${formData.name.replace(/\s+/g, '_')}_resume.pdf`);
//     });
//   };

//   // Download resume as DOCX
//   const downloadDOCX = () => {
//     // Create a simple HTML representation of the resume
//     const htmlContent = resumeRef.current.innerHTML;
    
//     // Convert HTML to a Blob containing .docx format
//     // In a real implementation, you would use a library like docx-html
//     // For this demo, we'll create a simple text file with HTML content
//     const blob = new Blob([htmlContent], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
//     saveAs(blob, `${formData.name.replace(/\s+/g, '_')}_resume.docx`);
//   };

//   // Template components
//   const renderModernTemplate = () => {
//     if (!generatedResume) return null;
    
//     return (
//       <div className="resume-modern">
//         <div className="resume-header">
//           <h1>{generatedResume.name}</h1>
//           <p>{generatedResume.location} | {generatedResume.phone} | {generatedResume.email}</p>
//         </div>
        
//         <div className="resume-section">
//           <h2>Summary</h2>
//           <div className="summary-content">
//             <p>{generatedResume.summary}</p>
//           </div>
//         </div>
        
//         <div className="resume-section">
//           <h2>Skills</h2>
//           <div className="skills-content">
//             {generatedResume.skills.filter(s => s).map((skill, idx) => (
//               <div key={idx} className="skill-item">{skill}</div>
//             ))}
//           </div>
//         </div>
        
//         <div className="resume-section">
//           <h2>Experience</h2>
//           {generatedResume.experience.map((exp, idx) => (
//             <div key={idx} className="experience-item">
//               <div className="experience-header">
//                 <h3>{exp.title}</h3>
//                 <p className="experience-company">{exp.company} — {exp.location}</p>
//                 <p className="experience-duration">{exp.duration}</p>
//               </div>
//               <ul className="experience-achievements">
//                 {exp.achievements.filter(a => a).map((achievement, aidx) => (
//                   <li key={aidx}>{achievement}</li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
        
//         <div className="resume-section">
//           <h2>Education and Training</h2>
//           {generatedResume.education.map((edu, idx) => (
//             <div key={idx} className="education-item">
//               <h3>{edu.degree}</h3>
//               <p>{edu.institution} — {edu.location}</p>
//               <p>{edu.year}</p>
//             </div>
//           ))}
//         </div>
        
//         <div className="resume-section">
//           <h2>Languages</h2>
//           <div className="languages-content">
//             {generatedResume.languages.map((lang, idx) => (
//               <div key={idx} className="language-item">
//                 <strong>{lang.name}:</strong> {lang.level}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderClassicTemplate = () => {
//     if (!generatedResume) return null;
    
//     return (
//       <div className="resume-classic">
//         <div className="resume-header-classic">
//           <h1>{generatedResume.name}</h1>
//           <p>{generatedResume.location} | {generatedResume.phone} | {generatedResume.email}</p>
//           <hr />
//         </div>
        
//         <div className="resume-section-classic">
//           <h2>Summary</h2>
//           <p>{generatedResume.summary}</p>
//         </div>
        
//         <div className="resume-section-classic">
//           <h2>Skills</h2>
//           <div className="skills-grid">
//             {generatedResume.skills.filter(s => s).map((skill, idx) => (
//               <div key={idx} className="skill-bullet">• {skill}</div>
//             ))}
//           </div>
//         </div>
        
//         <div className="resume-section-classic">
//           <h2>Experience</h2>
//           {generatedResume.experience.map((exp, idx) => (
//             <div key={idx} className="experience-classic">
//               <div className="exp-header">
//                 <div>
//                   <h3>{exp.title}</h3>
//                   <p>{exp.company} — {exp.location}</p>
//                 </div>
//                 <p className="exp-duration">{exp.duration}</p>
//               </div>
//               <ul>
//                 {exp.achievements.filter(a => a).map((achievement, aidx) => (
//                   <li key={aidx}>{achievement}</li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
        
//         <div className="resume-section-classic">
//           <h2>Education and Training</h2>
//           {generatedResume.education.map((edu, idx) => (
//             <div key={idx} className="education-classic">
//               <div className="edu-header">
//                 <div>
//                   <h3>{edu.degree}</h3>
//                   <p>{edu.institution} — {edu.location}</p>
//                 </div>
//                 <p>{edu.year}</p>
//               </div>
//             </div>
//           ))}
//         </div>
        
//         <div className="resume-section-classic">
//           <h2>Languages</h2>
//           <table className="language-table">
//             <tbody>
//               {generatedResume.languages.map((lang, idx) => (
//                 <tr key={idx}>
//                   <td><strong>{lang.name}:</strong></td>
//                   <td>{lang.level}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderMinimalistTemplate = () => {
//     if (!generatedResume) return null;
    
//     return (
//       <div className="resume-minimalist">
//         <div className="resume-header-minimalist">
//           <h1>{generatedResume.name}</h1>
//           <p>{generatedResume.location} | {generatedResume.phone} | {generatedResume.email}</p>
//         </div>
        
//         <div className="resume-section-minimalist">
//           <h2>Summary</h2>
//           <p>{generatedResume.summary}</p>
//         </div>
        
//         <div className="resume-section-minimalist">
//           <h2>Skills</h2>
//           <p>{generatedResume.skills.filter(s => s).join(' • ')}</p>
//         </div>
        
//         <div className="resume-section-minimalist">
//           <h2>Experience</h2>
//           {generatedResume.experience.map((exp, idx) => (
//             <div key={idx} className="experience-minimalist">
//               <h3>{exp.title} | {exp.company}</h3>
//               <p className="subtitle">{exp.location} | {exp.duration}</p>
//               <ul>
//                 {exp.achievements.filter(a => a).map((achievement, aidx) => (
//                   <li key={aidx}>{achievement}</li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
        
//         <div className="resume-section-minimalist">
//           <h2>Education</h2>
//           {generatedResume.education.map((edu, idx) => (
//             <div key={idx} className="education-minimalist">
//               <h3>{edu.degree}</h3>
//               <p className="subtitle">{edu.institution} | {edu.location} | {edu.year}</p>
//             </div>
//           ))}
//         </div>
        
//         <div className="resume-section-minimalist">
//           <h2>Languages</h2>
//           <p>{generatedResume.languages.map(l => `${l.name} (${l.level})`).join(' • ')}</p>
//         </div>
//       </div>
//     );
//   };

//   // Render appropriate template based on selection
//   const renderSelectedTemplate = () => {
//     if (!generatedResume) return null;
    
//     switch (selectedTemplate) {
//       case 'modern':
//         return renderModernTemplate();
//       case 'classic':
//         return renderClassicTemplate();
//       case 'minimalist':
//         return renderMinimalistTemplate();
//       default:
//         return renderModernTemplate();
//     }
//   };

//   return (
//     <div className="container">
//       <div className="app-header">
//         <h1>Professional Resume Builder with ATS Optimization</h1>
//         <p>Build a professional resume tailored to your target job and optimize it for ATS systems</p>
//       </div>
      
//       <div className="main-content">
//         <div className="sidebar">
//           <h2>Resume Information</h2>
          
//           <div className="form-section">
//             <h3>Personal Details</h3>
//             <div className="form-group">
//               <label>Full Name</label>
//               <input 
//                 type="text" 
//                 name="name" 
//                 value={formData.name} 
//                 onChange={handleInputChange} 
//                 placeholder="e.g., Diya Agarwal"
//               />
//             </div>
            
//             <div className="form-group">
//               <label>Location</label>
//               <input 
//                 type="text" 
//                 name="location" 
//                 value={formData.location} 
//                 onChange={handleInputChange} 
//                 placeholder="e.g., New Delhi, India 110034"
//               />
//             </div>
            
//             <div className="form-row">
//               <div className="form-group half">
//                 <label>Phone</label>
//                 <input 
//                   type="text" 
//                   name="phone" 
//                   value={formData.phone} 
//                   onChange={handleInputChange} 
//                   placeholder="e.g., +91 11 5555 3345"
//                 />
//               </div>
              
//               <div className="form-group half">
//                 <label>Email</label>
//                 <input 
//                   type="email" 
//                   name="email" 
//                   value={formData.email} 
//                   onChange={handleInputChange} 
//                   placeholder="e.g., d.agarwal@sample.in"
//                 />
//               </div>
//             </div>
//           </div>
          
//           <div className="form-section">
//             <h3>Target Job</h3>
//             <div className="form-group">
//               <label>Job Title</label>
//               <input 
//                 type="text" 
//                 name="jobTitle" 
//                 value={formData.jobTitle} 
//                 onChange={handleInputChange} 
//                 placeholder="e.g., Retail Sales Associate"
//               />
//             </div>
            
//             <div className="form-group">
//               <label>Job Description</label>
//               <textarea 
//                 name="jobDescription" 
//                 value={formData.jobDescription} 
//                 onChange={handleInputChange} 
//                 placeholder="Paste the full job description here..."
//                 rows="5"
//               ></textarea>
//             </div>
            
//             <button className="action-button" onClick={generateProfessionalSummary}>
//               Generate Professional Summary
//             </button>
//           </div>
          
//           <div className="form-section">
//             <h3>Skills</h3>
//             <div className="form-group skills-grid">
//               {formData.skills.map((skill, idx) => (
//                 <input 
//                   key={idx}
//                   type="text" 
//                   name={`skill-${idx}`}
//                   value={skill}
//                   onChange={(e) => {
//                     const newSkills = [...formData.skills];
//                     newSkills[idx] = e.target.value;
//                     setFormData({...formData, skills: newSkills});
//                   }}
//                   placeholder={`Skill ${idx + 1}`}
//                   className="skill-input"
//                 />
//               ))}
//             </div>
//           </div>
          
//           <div className="form-section">
//             <h3>Experience</h3>
//             {formData.experience.map((exp, idx) => (
//               <div key={idx} className="experience-form">
//                 <div className="form-group">
//                   <label>Job Title</label>
//                   <input 
//                     type="text" 
//                     name="title" 
//                     value={exp.title} 
//                     onChange={(e) => handleInputChange(e, 'experience', idx)} 
//                     placeholder="e.g., Retail Sales Associate"
//                   />
//                 </div>
                
//                 <div className="form-row">
//                   <div className="form-group half">
//                     <label>Company</label>
//                     <input 
//                       type="text" 
//                       name="company" 
//                       value={exp.company} 
//                       onChange={(e) => handleInputChange(e, 'experience', idx)} 
//                       placeholder="e.g., ZARA"
//                     />
//                   </div>
                  
//                   <div className="form-group half">
//                     <label>Location</label>
//                     <input 
//                       type="text" 
//                       name="location" 
//                       value={exp.location} 
//                       onChange={(e) => handleInputChange(e, 'experience', idx)} 
//                       placeholder="e.g., New Delhi, India"
//                     />
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Duration</label>
//                   <input 
//                     type="text" 
//                     name="duration" 
//                     value={exp.duration} 
//                     onChange={(e) => handleInputChange(e, 'experience', idx)} 
//                     placeholder="e.g., Feb 2017 to Current"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Achievements</label>
//                   {exp.achievements.map((achievement, aidx) => (
//                     <input 
//                       key={aidx}
//                       type="text" 
//                       name={aidx.toString()}
//                       value={achievement}
//                       onChange={(e) => handleInputChange(e, 'experience', idx, 'achievements')} 
//                       placeholder={`Achievement ${aidx + 1}`}
//                       className="achievement-input"
//                     />
//                   ))}
//                 </div>
                
//                 <div className="form-actions">
//                   {idx > 0 && (
//                     <button className="remove-button" onClick={() => removeItem('experience', idx)}>
//                       Remove Experience
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ))}
            
//             <button className="add-button" onClick={() => addItem('experience')}>
//               Add Experience
//             </button>
//           </div>
          
//           <div className="form-section">
//             <h3>Education</h3>
//             {formData.education.map((edu, idx) => (
//               <div key={idx} className="education-form">
//                 <div className="form-group">
//                   <label>Degree/Diploma</label>
//                   <input 
//                     type="text" 
//                     name="degree" 
//                     value={edu.degree} 
//                     onChange={(e) => handleInputChange(e, 'education', idx)} 
//                     placeholder="e.g., Diploma in Financial Accounting"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Institution</label>
//                   <input 
//                     type="text" 
//                     name="institution" 
//                     value={edu.institution} 
//                     onChange={(e) => handleInputChange(e, 'education', idx)} 
//                     placeholder="e.g., Oxford Software Institute"
//                   />
//                 </div>
                
//                 <div className="form-row">
//                   <div className="form-group half">
//                     <label>Location</label>
//                     <input 
//                       type="text" 
//                       name="location" 
//                       value={edu.location} 
//                       onChange={(e) => handleInputChange(e, 'education', idx)} 
//                       placeholder="e.g., New Delhi, India"
//                     />
//                   </div>
                  
//                   <div className="form-group half">
//                     <label>Year</label>
//                     <input 
//                       type="text" 
//                       name="year" 
//                       value={edu.year} 
//                       onChange={(e) => handleInputChange(e, 'education', idx)} 
//                       placeholder="e.g., 2016"
//                     />
//                   </div>
//                 </div>
                
//                 <div className="form-actions">
//                   {idx > 0 && (
//                     <button className="remove-button" onClick={() => removeItem('education', idx)}>
//                       Remove Education
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ))}
            
//             <button className="add-button" onClick={() => addItem('education')}>
//               Add Education
//             </button>
//           </div>
          
//           <div className="form-section">
//             <h3>Languages</h3>
//             {formData.languages.map((lang, idx) => (
//               <div key={idx} className="form-row">
//                 <div className="form-group half">
//                   <label>Language</label>
//                   <input 
//                     type="text" 
//                     name="name" 
//                     value={lang.name} 
//                     onChange={(e) => handleInputChange(e, 'languages', idx)} 
//                     placeholder="e.g., Hindi"
//                   />
//                 </div>
                
//                 <div className="form-group half">
//                   <label>Proficiency</label>
//                   <input 
//                     type="text" 
//                     name="level" 
//                     value={lang.level} 
//                     onChange={(e) => handleInputChange(e, 'languages', idx)} 
//                     placeholder="e.g., Native speaker or C2"
//                   />
//                 </div>
                
//                 {idx > 0 && (
//                   <button className="remove-button small" onClick={() => removeItem('languages', idx)}>
//                     ✕
//                   </button>
//                 )}
//               </div>
//             ))}
            
//             <button className="add-button" onClick={() => addItem('languages')}>
//               Add Language
//             </button>
//           </div>
          
//           <div className="action-buttons">
//             <button className="primary-button" onClick={generateResume}>
//               Generate Resume
//             </button>
//           </div>
//         </div>
        
//         <div className="main-panel">
//           <div className="tabs">
//             <button 
//               className={`tab-button ${!resumeText ? 'active' : ''}`}
//               onClick={() => setResumeText('')}
//             >
//               Resume Builder
//             </button>
//             <button 
//               className={`tab-button ${resumeText ? 'active' : ''}`}
//               onClick={() => setResumeText(document.getElementById('resume-preview')?.innerText || '')}
//             >
//               ATS Checker
//             </button>
//           </div>
          
//           {!resumeText ? (
//             <div className="resume-builder-panel">
//               <div className="template-selector">
//                 <label>Select Template:</label>
//                 <div className="template-options">
//                   <button 
//                     className={`template-option ${selectedTemplate === 'modern' ? 'selected' : ''}`}
//                     onClick={() => setSelectedTemplate('modern')}
//                   >
//                     Modern
//                   </button>
//                   <button 
//                     className={`template-option ${selectedTemplate === 'classic' ? 'selected' : ''}`}
//                     onClick={() => setSelectedTemplate('classic')}
//                   >
//                     Classic
//                   </button>
//                   <button 
//                     className={`template-option ${selectedTemplate === 'minimalist' ? 'selected' : ''}`}
//                     onClick={() => setSelectedTemplate('minimalist')}
//                   >
//                     Minimalist
//                   </button>
//                 </div>
//               </div>
              
//               <div className="resume-preview" id="resume-preview">
//                 <div ref={resumeRef}>
//                   {renderSelectedTemplate()}
//                 </div>
//               </div>
              
//               {generatedResume && (
//                 <div className="download-options">
//                   <button className="download-button" onClick={downloadPDF}>
//                     Download as PDF
//                   </button>
//                   <button className="download-button" onClick={downloadDOCX}>
//                     Download as DOCX
//                   </button>
//                 </div>
//               )}
//             </div>
//           ) : (
//             <div className="ats-checker-panel">
//               <div className="ats-form">
//                 <h3>ATS Resume Checker</h3>
//                 <p>Paste your resume text below to check its ATS score against the job description</p>
                
//                 <textarea 
//              className="resume-text-input"
//              value={resumeText}
//              onChange={(e) => setResumeText(e.target.value)}
//              placeholder="Paste your full resume text here..."
//              rows="10"
//            ></textarea>
           
//            <div className="action-buttons">
//              <button className="primary-button" onClick={calculateATSScore}>
//                Check ATS Score
//              </button>
//              <button className="secondary-button" onClick={optimizeResume} disabled={!resumeText}>
//                {isOptimizing ? 'Optimizing...' : 'Get Optimization Tips'}
//              </button>
//            </div>
//          </div>
         
//          {atsScore !== null && (
//            <div className="ats-results">
//              <div className="score-display">
//               <div className="score-circle" style={{background: `conic-gradient(#4CAF50 ${atsScore}%, #f3f3f3 0)`}}>                 <span className="score-text">{atsScore}%</span>
//                </div>
//                <p className="score-label">ATS Match Score</p>
//              </div>
             
//              <div className="keyword-analysis">
//                <div className="keyword-section">
//                  <h3>Matched Keywords ({matchedKeywords.length})</h3>
//                  <div className="keyword-tags">
//                    {matchedKeywords.map((keyword, idx) => (
//                      <span key={idx} className="keyword-tag matched">{keyword}</span>
//                    ))}
//                  </div>
//                </div>
               
//                <div className="keyword-section">
//                  <h3>Missing Keywords ({missedKeywords.length})</h3>
//                  <div className="keyword-tags">
//                    {missedKeywords.map((keyword, idx) => (
//                      <span key={idx} className="keyword-tag missing">{keyword}</span>
//                    ))}
//                  </div>
//                </div>
//              </div>
             
//              {optimizationSuggestions && (
//                <div className="optimization-suggestions">
//                  <h3>Resume Optimization Tips</h3>
                 
//                  <div className="suggestion-section">
//                    <h4>Keywords to Add</h4>
//                    <div className="keyword-tags">
//                      {optimizationSuggestions.addKeywords.map((keyword, idx) => (
//                        <span key={idx} className="keyword-tag suggestion">{keyword}</span>
//                      ))}
//                    </div>
//                  </div>
                 
//                  <div className="suggestion-section">
//                    <h4>Summary Improvements</h4>
//                    <p>{optimizationSuggestions.improveSummary}</p>
//                  </div>
                 
//                  <div className="suggestion-section">
//                    <h4>Format Improvements</h4>
//                    <ul>
//                      {optimizationSuggestions.formatImprovements.map((tip, idx) => (
//                        <li key={idx}>{tip}</li>
//                      ))}
//                    </ul>
//                  </div>
//                </div>
//              )}
//            </div>
//          )}
//        </div>
//      )}
//    </div>
//  </div>
// </div>
// );
// };

// export default ResumeBuilder;


import React, { useState, useRef } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaGithub, FaLinkedin, FaGlobe, FaGraduationCap, FaBriefcase, FaTools, FaCertificate, FaProjectDiagram, FaFileDownload, FaEdit, FaPlus, FaTrash, FaCheckCircle, FaTimes, FaMagic, FaLightbulb } from 'react-icons/fa';

const ResumeBuilder = () => {
  const [activeTab, setActiveTab] = useState('generator');
  const [jobTitle, setJobTitle] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [resume, setResume] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  
  // ATS Checker states
  const [atsResume, setAtsResume] = useState('');
  const [atsJobDesc, setAtsJobDesc] = useState('');
  const [atsResult, setAtsResult] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  
  // Personal info editing
  const [personalInfo, setPersonalInfo] = useState({
    name: 'John Doe',
    email: 'john.doe@email.com',
    phone: '+1 (555) 123-4567',
    github: 'github.com/johndoe',
    linkedin: 'linkedin.com/in/johndoe',
    portfolio: 'johndoe.dev',
    location: 'New York, NY'
  });
  
  const resumeRef = useRef(null);

  // Advanced keyword extraction with categorization
  const extractAdvancedKeywords = (text) => {
    const technicalSkills = [
      'JavaScript', 'Python', 'Java', 'C++', 'C#', 'Ruby', 'PHP', 'Swift', 'Kotlin', 'Go',
      'React', 'Angular', 'Vue.js', 'Node.js', 'Express', 'Django', 'Flask', 'Spring Boot',
      'TypeScript', 'HTML', 'CSS', 'SQL', 'NoSQL', 'MongoDB', 'PostgreSQL', 'MySQL',
      'AWS', 'Azure', 'GCP', 'Docker', 'Kubernetes', 'CI/CD', 'Jenkins', 'Git', 'GitHub',
      'REST API', 'GraphQL', 'Microservices', 'Agile', 'Scrum', 'DevOps', 'TDD',
      'Machine Learning', 'Deep Learning', 'AI', 'Data Science', 'TensorFlow', 'PyTorch',
      'Pandas', 'NumPy', 'Tableau', 'Power BI', 'Excel', 'Rust', 'WebAssembly',
      'Redux', 'Next.js', 'Tailwind CSS', 'Bootstrap', 'Material-UI', 'Figma', 'Adobe XD'
    ];
    
    const softSkills = [
      'Leadership', 'Communication', 'Team Collaboration', 'Problem Solving', 'Critical Thinking',
      'Time Management', 'Project Management', 'Analytical Thinking', 'Creativity', 'Adaptability',
      'Customer Service', 'Presentation', 'Negotiation', 'Conflict Resolution', 'Decision Making',
      'Strategic Planning', 'Mentoring', 'Cross-functional Collaboration', 'Stakeholder Management'
    ];
    
    const actionVerbs = [
      'developed', 'implemented', 'designed', 'built', 'created', 'managed', 'led', 'coordinated',
      'optimized', 'improved', 'increased', 'reduced', 'streamlined', 'automated', 'collaborated',
      'spearheaded', 'architected', 'delivered', 'achieved', 'established'
    ];
    
    const lowerText = text.toLowerCase();
    const found = {
      technical: [],
      soft: [],
      verbs: [],
      requirements: []
    };
    
    // Extract technical skills
    technicalSkills.forEach(skill => {
      if (lowerText.includes(skill.toLowerCase())) {
        found.technical.push(skill);
      }
    });
    
    // Extract soft skills
    softSkills.forEach(skill => {
      if (lowerText.includes(skill.toLowerCase())) {
        found.soft.push(skill);
      }
    });
    
    // Extract action verbs
    actionVerbs.forEach(verb => {
      if (lowerText.includes(verb)) {
        found.verbs.push(verb);
      }
    });
    
    // Extract years of experience
    const yearsMatch = text.match(/(\d+)\+?\s*(?:years?|yrs?).*?(?:experience|exp)/i);
    found.yearsRequired = yearsMatch ? parseInt(yearsMatch[1]) : null;
    
    // Extract degree requirements
    const degreeMatch = text.match(/bachelor'?s?|master'?s?|phd|degree/i);
    found.degreeRequired = degreeMatch ? degreeMatch[0] : null;
    
    return found;
  };

  // Determine industry and role category
  const determineRoleCategory = (title, description) => {
    const categories = {
      'Software Engineer': {
        keywords: ['software', 'engineer', 'developer', 'programmer', 'coding', 'backend', 'frontend', 'full stack'],
        focus: 'technical',
        emphasis: ['coding', 'system design', 'problem solving']
      },
      'Data Scientist': {
        keywords: ['data', 'scientist', 'analytics', 'machine learning', 'ai', 'ml'],
        focus: 'analytical',
        emphasis: ['statistical analysis', 'modeling', 'insights']
      },
      'Product Manager': {
        keywords: ['product', 'manager', 'roadmap', 'strategy', 'stakeholder'],
        focus: 'strategic',
        emphasis: ['strategy', 'communication', 'leadership']
      },
      'UX/UI Designer': {
        keywords: ['designer', 'ux', 'ui', 'user experience', 'design', 'wireframe'],
        focus: 'creative',
        emphasis: ['design thinking', 'user research', 'prototyping']
      },
      'DevOps Engineer': {
        keywords: ['devops', 'infrastructure', 'deployment', 'ci/cd', 'kubernetes', 'docker'],
        focus: 'technical',
        emphasis: ['automation', 'infrastructure', 'reliability']
      },
      'Marketing Manager': {
        keywords: ['marketing', 'campaign', 'brand', 'digital marketing', 'seo', 'content'],
        focus: 'creative',
        emphasis: ['strategy', 'creativity', 'analytics']
      },
      'Business Analyst': {
        keywords: ['business', 'analyst', 'requirements', 'process', 'stakeholder'],
        focus: 'analytical',
        emphasis: ['analysis', 'documentation', 'process improvement']
      },
      'Sales Manager': {
        keywords: ['sales', 'revenue', 'client', 'business development', 'account'],
        focus: 'interpersonal',
        emphasis: ['relationship building', 'negotiation', 'target achievement']
      }
    };
    
    const combinedText = (title + ' ' + description).toLowerCase();
    
    for (const [category, config] of Object.entries(categories)) {
      const matchCount = config.keywords.filter(kw => combinedText.includes(kw)).length;
      if (matchCount >= 2) {
        return { category, ...config };
      }
    }
    
    return { category: 'Professional', focus: 'general', emphasis: ['versatility', 'adaptability', 'growth'] };
  };

  // Generate professional summary with AI-like intelligence
  const generateSmartSummary = (title, description, keywords, roleInfo) => {
    const years = keywords.yearsRequired || (3 + Math.floor(Math.random() * 4));
    const tech = keywords.technical.slice(0, 4);
    const soft = keywords.soft.slice(0, 3);
    
    const summaries = {
      technical: [
        `Results-driven ${title} with ${years}+ years of experience specializing in ${tech[0]}, ${tech[1]}, and ${tech[2]}. Proven expertise in building scalable, high-performance applications and delivering innovative solutions. Strong ${soft[0]} and ${soft[1]} skills with a passion for clean code and best practices.`,
        
        `Accomplished ${title} bringing ${years}+ years of hands-on experience in ${tech[0]} and ${tech[1]} development. Demonstrated success in architecting robust systems, optimizing application performance, and mentoring development teams. Proficient in ${tech[2]} and ${tech[3]} with strong focus on ${roleInfo.emphasis[0]} and ${roleInfo.emphasis[1]}.`,
        
        `Dynamic ${title} with ${years}+ years of expertise in full-stack development using ${tech[0]}, ${tech[1]}, and ${tech[2]}. Track record of delivering high-impact projects, improving system efficiency by 40%, and collaborating with cross-functional teams. Strong advocate for ${roleInfo.emphasis[0]} and continuous learning.`
      ],
      analytical: [
        `Data-driven ${title} with ${years}+ years of experience leveraging ${tech[0]}, ${tech[1]}, and advanced analytics to drive business insights. Proven ability to transform complex datasets into actionable strategies, resulting in measurable business impact. Expert in ${soft[0]} and ${soft[1]} with strong technical acumen.`,
        
        `Strategic ${title} bringing ${years}+ years of expertise in ${tech[0]} and ${tech[1]}. Specialized in uncovering patterns, building predictive models, and presenting insights to stakeholders. Adept at ${roleInfo.emphasis[0]} and ${roleInfo.emphasis[1]} with proven success in data-driven decision making.`
      ],
      strategic: [
        `Strategic ${title} with ${years}+ years of experience driving product vision and delivering customer-centric solutions. Expertise in ${soft[0]}, ${soft[1]}, and cross-functional leadership. Proven track record of launching successful products, increasing user engagement by 50%, and aligning business goals with technical execution.`,
        
        `Visionary ${title} bringing ${years}+ years of product development experience. Expert in ${roleInfo.emphasis[0]}, ${roleInfo.emphasis[1]}, and stakeholder management. Successfully led multiple product launches, conducted market research, and collaborated with engineering teams to deliver innovative solutions.`
      ],
      creative: [
        `Creative ${title} with ${years}+ years of experience crafting intuitive, user-centered designs. Proficient in ${tech[0]}, ${tech[1]}, and ${tech[2]} with strong focus on ${roleInfo.emphasis[0]} and ${roleInfo.emphasis[1]}. Track record of improving user satisfaction by 45% through innovative design solutions and iterative testing.`,
        
        `Innovative ${title} bringing ${years}+ years of design expertise. Specialized in ${roleInfo.emphasis[0]}, user research, and prototyping. Successfully designed and launched multiple products, collaborated with development teams, and maintained design systems for scalable solutions.`
      ],
      interpersonal: [
        `Achievement-oriented ${title} with ${years}+ years of experience exceeding sales targets and building lasting client relationships. Expert in ${soft[0]}, ${soft[1]}, and revenue generation. Proven track record of increasing sales by 60%, expanding market share, and leading high-performing teams.`,
        
        `Dynamic ${title} bringing ${years}+ years of client-facing experience and consistent record of surpassing quotas. Skilled in ${roleInfo.emphasis[0]}, ${roleInfo.emphasis[1]}, and strategic account management. Successfully closed deals worth $5M+ and maintained 95% client retention rate.`
      ],
      general: [
        `Versatile ${title} with ${years}+ years of professional experience delivering exceptional results. Strong ${soft[0]} and ${soft[1]} skills with proven ability to adapt to new challenges. Track record of improving processes, collaborating effectively with teams, and driving organizational success.`
      ]
    };
    
    const categoryTemplates = summaries[roleInfo.focus] || summaries.general;
    return categoryTemplates[Math.floor(Math.random() * categoryTemplates.length)];
  };

  // Generate comprehensive skills list
  const generateComprehensiveSkills = (keywords, roleInfo) => {
    const allSkills = [...keywords.technical, ...keywords.soft];
    
    // Add role-specific skills
    const roleSkills = {
      technical: ['System Architecture', 'Code Review', 'Performance Optimization', 'Testing', 'Debugging'],
      analytical: ['Data Visualization', 'Statistical Modeling', 'A/B Testing', 'ETL Pipelines', 'Reporting'],
      strategic: ['Roadmap Planning', 'Market Research', 'User Stories', 'Prioritization', 'KPI Tracking'],
      creative: ['Wireframing', 'Prototyping', 'User Testing', 'Design Systems', 'Accessibility'],
      interpersonal: ['Client Relations', 'Pipeline Management', 'Contract Negotiation', 'CRM Systems']
    };
    
    const additional = roleSkills[roleInfo.focus] || roleSkills.technical;
    return [...new Set([...allSkills, ...additional])].slice(0, 14);
  };

  // Generate detailed work experience
  const generateDetailedExperience = (title, keywords, roleInfo) => {
    const currentYear = new Date().getFullYear();
    const tech = keywords.technical;
    const verbs = keywords.verbs.length > 0 ? keywords.verbs : ['developed', 'implemented', 'designed', 'built'];
    
    const achievements = {
      technical: [
        `${verbs[0].charAt(0).toUpperCase() + verbs[0].slice(1)} and deployed microservices architecture using ${tech[0] || 'modern technologies'}, reducing system latency by 45%`,
        `${verbs[1].charAt(0).toUpperCase() + verbs[1].slice(1)} automated CI/CD pipelines, decreasing deployment time from 2 hours to 15 minutes`,
        `Led code review process and mentored 5 junior developers in best practices and ${tech[1] || 'software design patterns'}`,
        `Optimized database queries and application performance, improving response time by 60%`,
        `Collaborated with product and design teams to deliver 15+ features, increasing user engagement by 35%`,
        `Architected scalable solutions handling 1M+ daily active users with 99.9% uptime`
      ],
      analytical: [
        `Analyzed large-scale datasets using ${tech[0] || 'Python'} and ${tech[1] || 'SQL'}, uncovering insights that drove $2M in revenue`,
        `Built predictive models with 92% accuracy, enabling proactive decision-making for business strategy`,
        `Created interactive dashboards using ${tech[2] || 'Tableau'}, improving stakeholder visibility by 70%`,
        `Conducted A/B testing on 20+ product features, optimizing conversion rates by 28%`,
        `Developed automated reporting systems, reducing manual work by 40 hours per week`,
        `Presented data-driven recommendations to C-level executives, influencing key business decisions`
      ],
      strategic: [
        `Led product roadmap planning for 3 major releases, increasing user adoption by 50%`,
        `Conducted market research and user interviews with 100+ customers, identifying key pain points`,
        `Collaborated with engineering teams to prioritize features based on business value and technical feasibility`,
        `Defined KPIs and success metrics, tracking product performance and iterating based on data`,
        `Managed cross-functional team of 10+ members, delivering projects 20% ahead of schedule`,
        `Launched new product line generating $3M in annual recurring revenue`
      ],
      creative: [
        `Designed intuitive user interfaces for web and mobile applications, improving user satisfaction by 45%`,
        `Conducted user research and usability testing with 50+ participants, informing design decisions`,
        `Created comprehensive design system with 100+ reusable components, ensuring brand consistency`,
        `Collaborated with developers to implement responsive designs across 5 platforms`,
        `Redesigned checkout flow, reducing cart abandonment rate by 32%`,
        `Won 2 design awards for innovative product experiences and accessibility improvements`
      ],
      interpersonal: [
        `Exceeded sales quotas by 150% for 3 consecutive quarters, generating $4M in new business`,
        `Built and maintained relationships with 50+ key enterprise clients, achieving 98% retention rate`,
        `Negotiated contracts worth $10M+, securing favorable terms and long-term partnerships`,
        `Developed sales strategies resulting in 40% market share growth in target segments`,
        `Trained and mentored team of 8 sales representatives, improving team performance by 35%`,
        `Identified new business opportunities, expanding into 3 additional markets`
      ]
    };
    
    const selectedAchievements = achievements[roleInfo.focus] || achievements.technical;
    
    return [
      {
        title: `Senior ${title}`,
        company: 'Tech Innovations Inc.',
        location: 'San Francisco, CA',
        duration: `${currentYear - 2} - Present`,
        responsibilities: [
          selectedAchievements[0],
          selectedAchievements[1],
          selectedAchievements[2],
          selectedAchievements[3]
        ]
      },
      {
        title: title,
        company: 'Digital Solutions Corp.',
        location: 'New York, NY',
        duration: `${currentYear - 5} - ${currentYear - 2}`,
        responsibilities: [
          selectedAchievements[4],
          selectedAchievements[5] || selectedAchievements[3],
          selectedAchievements[2] || selectedAchievements[1],
          selectedAchievements[0]
        ]
      }
    ];
  };

  // Generate relevant projects
  const generateRelevantProjects = (keywords, roleInfo) => {
    const tech = keywords.technical;
    
    const projects = {
      technical: [
        {
          name: 'E-Commerce Microservices Platform',
          description: `Architected and developed a scalable e-commerce platform using ${tech[0] || 'React'}, ${tech[1] || 'Node.js'}, and ${tech[2] || 'PostgreSQL'}. Implemented microservices architecture, payment gateway integration, and real-time inventory management. Achieved 99.9% uptime and handled 10K+ concurrent users.`,
          technologies: tech.slice(0, 5).join(', ') || 'React, Node.js, PostgreSQL, AWS, Docker',
          link: 'github.com/johndoe/ecommerce-platform'
        },
        {
          name: 'Real-Time Analytics Dashboard',
          description: `Built comprehensive analytics dashboard with live data visualization and reporting capabilities. Integrated multiple data sources, implemented caching strategies, and optimized for performance. Reduced data processing time by 65%.`,
          technologies: tech.slice(0, 4).join(', ') || 'React, D3.js, Redis, WebSocket',
          link: 'github.com/johndoe/analytics-dashboard'
        }
      ],
      analytical: [
        {
          name: 'Customer Churn Prediction Model',
          description: `Developed machine learning model to predict customer churn with 89% accuracy using ${tech[0] || 'Python'}, ${tech[1] || 'TensorFlow'}, and ensemble methods. Analyzed 2M+ customer records, engineered 50+ features, and deployed model to production, saving $1.5M annually.`,
          technologies: tech.slice(0, 4).join(', ') || 'Python, TensorFlow, Pandas, SQL',
          link: 'github.com/johndoe/churn-prediction'
        },
        {
          name: 'Sales Forecasting System',
          description: `Built time-series forecasting system using ARIMA and LSTM models to predict quarterly sales. Created automated pipeline for data collection, processing, and visualization. Improved forecast accuracy by 40%.`,
          technologies: tech.slice(0, 4).join(', ') || 'Python, PyTorch, Tableau, AWS',
          link: 'github.com/johndoe/sales-forecast'
        }
      ],
      strategic: [
        {
          name: 'Product Launch: Mobile Banking App',
          description: `Led end-to-end product development for mobile banking application serving 500K+ users. Defined product requirements, prioritized features, coordinated with engineering and design teams. Achieved 4.8-star rating and 200K downloads in first 3 months.`,
          technologies: 'Product Management, User Research, Agile, Analytics',
          link: ''
        }
      ],
      creative: [
        {
          name: 'Healthcare Patient Portal Redesign',
          description: `Redesigned patient portal improving user experience and accessibility. Conducted user research with 100+ patients, created wireframes and prototypes using ${tech[0] || 'Figma'}. Reduced task completion time by 50% and increased patient satisfaction scores by 35%.`,
          technologies: tech.slice(0, 3).join(', ') || 'Figma, Adobe XD, InVision',
          link: 'behance.net/johndoe/patient-portal'
        }
      ]
    };
    
    return projects[roleInfo.focus] || projects.technical;
  };

  // Generate certifications
  const generateRelevantCertifications = (keywords, roleInfo) => {
    const certs = {
      technical: [
        'AWS Certified Solutions Architect - Professional',
        'Microsoft Certified: Azure Developer Associate',
        'Certified Kubernetes Administrator (CKA)',
        'Google Cloud Professional Cloud Architect'
      ],
      analytical: [
        'Google Data Analytics Professional Certificate',
        'IBM Data Science Professional Certificate',
        'Microsoft Certified: Data Analyst Associate',
        'AWS Certified Machine Learning - Specialty'
      ],
      strategic: [
        'Certified Scrum Product Owner (CSPO)',
        'Product Management Certificate - Stanford University',
        'Project Management Professional (PMP)',
        'SAFe Product Owner/Product Manager'
      ],
      creative: [
        'Adobe Certified Expert (ACE)',
        'Google UX Design Professional Certificate',
        'Certified User Experience Professional (CUXP)',
        'Nielsen Norman Group UX Certification'
      ],
      interpersonal: [
        'Certified Professional Sales Person (CPSP)',
        'Salesforce Certified Administrator',
        'HubSpot Sales Software Certification',
        'Strategic Account Management Association (SAMA) Certificate'
      ]
    };
    
    const relevant = certs[roleInfo.focus] || certs.technical;
    return relevant.slice(0, 2);
  };

  // Main resume generation function
  const generateResume = async () => {
    if (!jobTitle || !jobDescription) {
      alert('Please enter both job title and description');
      return;
    }

    setIsGenerating(true);
    
    await new Promise(resolve => setTimeout(resolve, 2500));

    const keywords = extractAdvancedKeywords(jobDescription);
    const roleInfo = determineRoleCategory(jobTitle, jobDescription);
    
    const generatedResume = {
      personalInfo: { ...personalInfo },
      summary: generateSmartSummary(jobTitle, jobDescription, keywords, roleInfo),
      skills: generateComprehensiveSkills(keywords, roleInfo),
      experience: generateDetailedExperience(jobTitle, keywords, roleInfo),
      projects: generateRelevantProjects(keywords, roleInfo),
      education: [
        {
          degree: 'Bachelor of Science in Computer Science',
          institution: 'University of Technology',
          year: '2015 - 2019',
          gpa: '3.8/4.0'
        }
      ],
      certifications: generateRelevantCertifications(keywords, roleInfo),
      roleCategory: roleInfo.category
    };

    setResume(generatedResume);
    setIsGenerating(false);
  };

  // Edit handlers
  const updatePersonalInfo = (field, value) => {
    setPersonalInfo(prev => ({...prev, [field]: value}));
    if (resume) {
      setResume(prev => ({
        ...prev,
        personalInfo: { ...prev.personalInfo, [field]: value }
      }));
    }
  };

  const updateSummary = (value) => {
    setResume(prev => ({ ...prev, summary: value }));
  };

  const addSkill = () => {
    const skill = window.prompt('Enter new skill:');
    if (skill) {
      setResume(prev => ({
        ...prev,
        skills: [...prev.skills, skill]
      }));
    }
  };

  const removeSkill = (index) => {
    setResume(prev => ({
      ...prev,
      skills: prev.skills.filter((_, i) => i !== index)
    }));
  };

  const addExperience = () => {
    const newExp = {
      title: 'Job Title',
      company: 'Company Name',
      location: 'Location',
      duration: 'Start - End',
      responsibilities: ['Add responsibility here']
    };
    setResume(prev => ({
      ...prev,
      experience: [...prev.experience, newExp]
    }));
  };

  const updateExperience = (index, field, value) => {
    setResume(prev => ({
      ...prev,
      experience: prev.experience.map((exp, i) => 
        i === index ? { ...exp, [field]: value } : exp
      )
    }));
  };

  const removeExperience = (index) => {
    setResume(prev => ({
      ...prev,
      experience: prev.experience.filter((_, i) => i !== index)
    }));
  };

  const addProject = () => {
    const newProject = {
      name: 'Project Name',
      description: 'Project description',
      technologies: 'Technologies used',
      link: ''
    };
    setResume(prev => ({
      ...prev,
      projects: [...prev.projects, newProject]
    }));
  };

  const updateProject = (index, field, value) => {
    setResume(prev => ({
      ...prev,
      projects: prev.projects.map((proj, i) => 
        i === index ? { ...proj, [field]: value } : proj
      )
    }));
  };

  const removeProject = (index) => {
    setResume(prev => ({
      ...prev,
      projects: prev.projects.filter((_, i) => i !== index)
    }));
  };

  // Download as PDF
  const downloadAsPDF = () => {
    const printWindow = window.open('', '', 'height=900,width=800');
    const resumeHTML = resumeRef.current.innerHTML;
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Resume - ${resume.personalInfo.name}</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body { 
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              margin: 0;
              padding: 40px;
              color: #333;
              background: white;
            }
            h1 { 
              font-size: 36px;
              font-weight: 700;
              margin-bottom: 8px;
              color: #1a1a1a;
            }
            .contact-info { 
              font-size: 14px;
              color: #666;
              margin-bottom: 24px;
            }
            .section-title { 
              color: #0d6efd;
              font-size: 20px;
              font-weight: 700;
              border-bottom: 3px solid #0d6efd;
              margin-top: 28px;
              margin-bottom: 16px;
              padding-bottom: 6px;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
            .skills-container { 
              display: flex;
              flex-wrap: wrap;
              gap: 10px;
              margin-bottom: 20px;
            }
            .skill-badge { 
              background: #e9ecef;
              padding: 6px 14px;
              border-radius: 5px;
              font-size: 13px;
              font-weight: 500;
            }
            .experience-item, .project-item { 
              margin-bottom: 24px;
              page-break-inside: avoid;
            }
            .experience-header { 
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              margin-bottom: 6px;
            }
            .job-title { 
              font-weight: 700;
              font-size: 17px;
              color: #1a1a1a;
            }
            .company { 
              color: #666;
              margin-bottom: 10px;
              font-size: 15px;
            }
            ul { 
              margin: 0;
              padding-left: 22px;
            }
            li { 
              margin-bottom: 8px;
              font-size: 14px;
              line-height: 1.7;
              color: #444;
            }
            p {
              margin: 6px 0;
              font-size: 14px;
              line-height: 1.7;
              color: #444;
            }
            .project-name {
              font-weight: 700;
              font-size: 16px;
              color: #1a1a1a;
              margin-bottom: 6px;
            }
            @media print {
              body { margin: 20px; padding: 0; }
              .page-break { page-break-after: always; }
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${resumeHTML}
        </body>
      </html>
    `);
    
    printWindow.document.close();
  };

  // Download as DOCX (text format)
  const downloadAsDOCX = () => {
    let content = `${resume.personalInfo.name}\n`;
    content += `${resume.personalInfo.email} | ${resume.personalInfo.phone}\n`;
    content += `${resume.personalInfo.linkedin} | ${resume.personalInfo.github} | ${resume.personalInfo.portfolio}\n`;
    content += `${resume.personalInfo.location}\n\n`;
    content += `${'='.repeat(80)}\n\n`;
    content += `PROFESSIONAL SUMMARY\n${'-'.repeat(80)}\n`;
    content += `${resume.summary}\n\n`;
    content += `SKILLS\n${'-'.repeat(80)}\n`;
    content += `${resume.skills.join(' • ')}\n\n`;
    content += `WORK EXPERIENCE\n${'-'.repeat(80)}\n\n`;
    resume.experience.forEach(exp => {
      content += `${exp.title}\n`;
      content += `${exp.company} | ${exp.location}\n`;
      content += `${exp.duration}\n`;
      exp.responsibilities.forEach(resp => content += `  • ${resp}\n`);
      content += `\n`;
    });
    content += `PROJECTS\n${'-'.repeat(80)}\n\n`;
    resume.projects.forEach(proj => {
      content += `${proj.name}\n`;
      content += `${proj.description}\n`;
      content += `Technologies: ${proj.technologies}\n\n`;
    });
    content += `EDUCATION\n${'-'.repeat(80)}\n`;
    resume.education.forEach(edu => {
      content += `${edu.degree}\n`;
      content += `${edu.institution} | ${edu.year} | GPA: ${edu.gpa}\n\n`;
    });
    content += `CERTIFICATIONS\n${'-'.repeat(80)}\n`;
    resume.certifications.forEach(cert => content += `  • ${cert}\n`);
    
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${resume.personalInfo.name.replace(/\s/g, '_')}_Resume.doc`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // ATS Checker
  const analyzeATS = async () => {
    if (!atsResume || !atsJobDesc) {
      alert('Please provide both resume text and job description');
      return;
    }

    setIsAnalyzing(true);
    await new Promise(resolve => setTimeout(resolve, 2000));

    const resumeKeywords = extractAdvancedKeywords(atsResume);
    const jobKeywords = extractAdvancedKeywords(atsJobDesc);
    
    const allResumeKeywords = [...resumeKeywords.technical, ...resumeKeywords.soft];
    const allJobKeywords = [...jobKeywords.technical, ...jobKeywords.soft];
    
    const matchedKeywords = allResumeKeywords.filter(kw => 
      allJobKeywords.some(jk => jk.toLowerCase() === kw.toLowerCase())
    );
    
    const score = allJobKeywords.length > 0 
      ? Math.min(95, Math.round((matchedKeywords.length / allJobKeywords.length) * 100)) 
      : 0;
    
    const missingKeywords = allJobKeywords.filter(jk => 
      !matchedKeywords.some(mk => mk.toLowerCase() === jk.toLowerCase())
    );

    const suggestions = generateATSSuggestions(score, missingKeywords, jobKeywords, resumeKeywords);

    setAtsResult({
      score,
      matchedKeywords,
      missingKeywords: missingKeywords.slice(0, 12),
      suggestions
    });
    
    setIsAnalyzing(false);
  };

  const generateATSSuggestions = (score, missing, jobKeywords, resumeKeywords) => {
    const suggestions = [];
    
    if (score < 50) {
      suggestions.push('❌ Critical: Your resume needs significant improvements to pass ATS screening');
      suggestions.push('🔄 Restructure your resume to align closely with the job requirements');
      suggestions.push('📝 Add specific keywords and skills mentioned in the job description');
    } else if (score < 70) {
      suggestions.push('⚠️ Your resume has potential but needs optimization for better ATS compatibility');
      suggestions.push('💡 Add more relevant technical and soft skills from the job posting');
      suggestions.push('📊 Quantify your achievements with specific metrics and numbers');
    } else if (score < 85) {
      suggestions.push('✅ Good match! Your resume is well-aligned with the job requirements');
      suggestions.push('🎯 Fine-tune by adding a few more specific keywords');
      suggestions.push('📈 Consider adding more quantifiable achievements');
    } else {
      suggestions.push('🎉 Excellent! Your resume is highly optimized for this position');
      suggestions.push('⭐ Your skills and experience align perfectly with requirements');
      suggestions.push('💪 Focus on tailoring your cover letter to stand out further');
    }
    
    if (missing.length > 0) {
      const topMissing = missing.slice(0, 5).join(', ');
      suggestions.push(`🔑 Key missing keywords: ${topMissing}`);
      suggestions.push('📌 Integrate these keywords naturally into your experience and skills sections');
    }
    
    suggestions.push('✍️ Use action verbs to start your bullet points (e.g., Developed, Implemented, Led)');
    suggestions.push('📋 Keep formatting simple and ATS-friendly (avoid tables, images, or complex layouts)');
    suggestions.push('🎓 Include relevant certifications and education prominently');
    suggestions.push('🔗 Add links to portfolio, GitHub, or LinkedIn if applicable');
    
    if (jobKeywords.yearsRequired && resumeKeywords.yearsRequired) {
      if (resumeKeywords.yearsRequired < jobKeywords.yearsRequired) {
        suggestions.push(`⏰ Job requires ${jobKeywords.yearsRequired}+ years - emphasize your relevant experience`);
      }
    }
    
    return suggestions;
  };

  return (
    <div className="min-vh-100 my-5 py-5" style={{ backgroundColor: '#f5f7fa' }}>
      <div className="container py-3 ">
        {/* Tab Navigation */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body p-0">
                <div className="d-flex">
                  <button 
                    className={`btn btn-lg flex-fill rounded-0 ${activeTab === 'generator' ? 'btn-primary' : 'btn-light text-dark'}`}
                    style={{ borderBottom: activeTab === 'generator' ? '3px solid #0d6efd' : 'none', fontWeight: '600' }}
                    onClick={() => setActiveTab('generator')}
                  >
                    <FaBriefcase className="me-2" />
                    AI Resume Generator
                  </button>
                  <button 
                    className={`btn btn-lg flex-fill rounded-0 ${activeTab === 'ats' ? 'btn-primary' : 'btn-light text-dark'}`}
                    style={{ borderBottom: activeTab === 'ats' ? '3px solid #0d6efd' : 'none', fontWeight: '600' }}
                    onClick={() => setActiveTab('ats')}
                  >
                    <FaCheckCircle className="me-2" />
                    ATS Score Checker
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Resume Generator Tab */}
        {activeTab === 'generator' && (
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="card shadow-sm border-0 sticky-top" style={{ top: '20px' }}>
                <div className="card-body">
                  <h4 className="card-title fw-bold mb-4 text-primary">
                    <FaLightbulb className="me-2" />
                    Generate Resume
                  </h4>
                  
                  {/* Personal Info Section */}
                  <div className="mb-4">
                    <h6 className="fw-bold mb-3">Personal Information</h6>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Full Name"
                        value={personalInfo.name}
                        onChange={(e) => updatePersonalInfo('name', e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        placeholder="Email"
                        value={personalInfo.email}
                        onChange={(e) => updatePersonalInfo('email', e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Phone"
                        value={personalInfo.phone}
                        onChange={(e) => updatePersonalInfo('phone', e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Location"
                        value={personalInfo.location}
                        onChange={(e) => updatePersonalInfo('location', e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="LinkedIn"
                        value={personalInfo.linkedin}
                        onChange={(e) => updatePersonalInfo('linkedin', e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="GitHub"
                        value={personalInfo.github}
                        onChange={(e) => updatePersonalInfo('github', e.target.value)}
                      />
                    </div>
                  </div>

                  <hr />

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      <FaBriefcase className="me-2 text-primary" />
                      Target Job Title
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="e.g., Senior Software Engineer, Data Scientist, Product Manager"
                      value={jobTitle}
                      onChange={(e) => setJobTitle(e.target.value)}
                    />
                    <small className="text-muted">Enter the exact job title you're applying for</small>
                  </div>
                  
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <FaFileDownload className="me-2 text-primary" />
                      Job Description
                    </label>
                    <textarea
                      className="form-control"
                      rows="14"
                      placeholder="Paste the complete job description here... 

Include:
• Required skills and technologies
• Years of experience needed
• Key responsibilities
• Qualifications and education
• Nice-to-have skills

The more detail you provide, the better your resume will be!"
                      value={jobDescription}
                      onChange={(e) => setJobDescription(e.target.value)}
                      style={{ fontSize: '13px' }}
                    />
                    <small className="text-muted">
                      💡 Tip: Paste the entire job posting for best results
                    </small>
                  </div>
                  
                  <button 
                    className="btn btn-primary w-100 py-3 fw-semibold"
                    onClick={generateResume}
                    disabled={isGenerating}
                  >
                    {isGenerating ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Generating Your Perfect Resume...
                      </>
                    ) : (
                      <>
                        <FaMagic className="me-2" />
                        Generate AI-Powered Resume
                      </>
                    )}
                  </button>

                  {resume && (
                    <div className="mt-3">
                      <div className="alert alert-success mb-0" role="alert">
                        <FaCheckCircle className="me-2" />
                        <strong>Success!</strong> Resume generated for: {resume.roleCategory}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              {resume ? (
                <>
                  <div className="card shadow-sm border-0 mb-3">
                    <div className="card-body py-3">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div>
                          <h5 className="mb-0 fw-bold">Your Tailored Resume</h5>
                          <small className="text-muted">Optimized for: {resume.roleCategory}</small>
                        </div>
                        <div className="btn-group">
                          <button 
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => setIsEditing(!isEditing)}
                          >
                            <FaEdit className="me-1" />
                            {isEditing ? 'Done' : 'Edit'}
                          </button>
                          <button 
                            className="btn btn-success btn-sm"
                            onClick={downloadAsPDF}
                          >
                            <FaFileDownload className="me-1" />
                            PDF
                          </button>
                          <button 
                            className="btn btn-info btn-sm text-white"
                            onClick={downloadAsDOCX}
                          >
                            <FaFileDownload className="me-1" />
                            DOC
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-sm border-0" style={{ maxHeight: '900px', overflowY: 'auto' }}>
                    <div className="card-body p-5 bg-white" ref={resumeRef}>
                      {/* Header */}
                      <div className="text-center mb-4 pb-4 border-bottom">
                        <h1 className="fw-bold mb-2" style={{ fontSize: '36px', color: '#1a1a1a' }}>
                          {resume.personalInfo.name}
                        </h1>
                        <div className="contact-info" style={{ fontSize: '14px', color: '#666' }}>
                          <div className="mb-1">
                            <FaEnvelope className="me-2" />{resume.personalInfo.email}
                            <span className="mx-3">|</span>
                            <FaPhone className="me-2" />{resume.personalInfo.phone}
                          </div>
                          <div className="mb-1">
                            <FaLinkedin className="me-2" />{resume.personalInfo.linkedin}
                            <span className="mx-3">|</span>
                            <FaGithub className="me-2" />{resume.personalInfo.github}
                          </div>
                          <div>
                            <FaGlobe className="me-2" />{resume.personalInfo.portfolio}
                            <span className="mx-3">|</span>
                            {resume.personalInfo.location}
                          </div>
                        </div>
                      </div>

                      {/* Professional Summary */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '20px', borderBottom: '3px solid #0d6efd', paddingBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          PROFESSIONAL SUMMARY
                        </h2>
                        {isEditing ? (
                          <textarea
                            className="form-control"
                            rows="5"
                            value={resume.summary}
                            onChange={(e) => updateSummary(e.target.value)}
                          />
                        ) : (
                          <p style={{ fontSize: '14px', lineHeight: '1.8', color: '#444', textAlign: 'justify' }}>
                            {resume.summary}
                          </p>
                        )}
                      </div>

                      {/* Skills */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '20px', borderBottom: '3px solid #0d6efd', paddingBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          SKILLS
                          {isEditing && (
                            <button className="btn btn-sm btn-success ms-3" onClick={addSkill}>
                              <FaPlus className="me-1" /> Add
                            </button>
                          )}
                        </h2>
                        <div className="skills-container d-flex flex-wrap gap-2">
                          {resume.skills.map((skill, idx) => (
                            <span 
                              key={idx} 
                              className="badge skill-badge px-3 py-2"
                              style={{ 
                                backgroundColor: '#e9ecef', 
                                color: '#333',
                                fontSize: '13px',
                                fontWeight: '500'
                              }}
                            >
                              {skill}
                              {isEditing && (
                                <FaTimes 
                                  className="ms-2 text-danger" 
                                  style={{ cursor: 'pointer', fontSize: '11px' }}
                                  onClick={() => removeSkill(idx)}
                                />
                              )}
                            </span>
                          ))}
                        </div>
                      </div>

                      {/* Work Experience */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '20px', borderBottom: '3px solid #0d6efd', paddingBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          WORK EXPERIENCE
                          {isEditing && (
                            <button className="btn btn-sm btn-success ms-3" onClick={addExperience}>
                              <FaPlus className="me-1" /> Add
                            </button>
                          )}
                        </h2>
                        {resume.experience.map((exp, idx) => (
                          <div key={idx} className="experience-item mb-4">
                            {isEditing ? (
                              <>
                                <div className="row g-2 mb-2">
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.title}
                                      onChange={(e) => updateExperience(idx, 'title', e.target.value)}
                                      placeholder="Job Title"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.duration}
                                      onChange={(e) => updateExperience(idx, 'duration', e.target.value)}
                                      placeholder="Duration"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.company}
                                      onChange={(e) => updateExperience(idx, 'company', e.target.value)}
                                      placeholder="Company"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={exp.location}
                                      onChange={(e) => updateExperience(idx, 'location', e.target.value)}
                                      placeholder="Location"
                                    />
                                  </div>
                                </div>
                                <button 
                                  className="btn btn-sm btn-danger mb-2"
                                  onClick={() => removeExperience(idx)}
                                >
                                  <FaTrash className="me-1" /> Remove
                                </button>
                              </>
                            ) : (
                              <>
                                <div className="experience-header d-flex justify-content-between align-items-start mb-2">
                                  <h3 className="job-title fw-bold mb-0" style={{ fontSize: '17px', color: '#1a1a1a' }}>
                                    {exp.title}
                                  </h3>
                                  <span style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>
                                    {exp.duration}
                                  </span>
                                </div>
                                <p className="company mb-3" style={{ fontSize: '15px', color: '#666' }}>
                                  {exp.company} | {exp.location}
                                </p>
                              </>
                            )}
                            <ul style={{ paddingLeft: '22px', margin: 0 }}>
                              {exp.responsibilities.map((resp, rIdx) => (
                                <li key={rIdx} style={{ fontSize: '14px', color: '#444', marginBottom: '8px', lineHeight: '1.7' }}>
                                  {resp}
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>

                      {/* Projects */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '20px', borderBottom: '3px solid #0d6efd', paddingBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          KEY PROJECTS
                          {isEditing && (
                            <button className="btn btn-sm btn-success ms-3" onClick={addProject}>
                              <FaPlus className="me-1" /> Add
                            </button>
                          )}
                        </h2>
                        {resume.projects.map((proj, idx) => (
                          <div key={idx} className="project-item mb-3">
                            {isEditing ? (
                              <>
                                <input
                                  type="text"
                                  className="form-control form-control-sm mb-2"
                                  value={proj.name}
                                  onChange={(e) => updateProject(idx, 'name', e.target.value)}
                                  placeholder="Project Name"
                                />
                                <textarea
                                  className="form-control form-control-sm mb-2"
                                  rows="3"
                                  value={proj.description}
                                  onChange={(e) => updateProject(idx, 'description', e.target.value)}
                                  placeholder="Description"
                                />
                                <input
                                  type="text"
                                  className="form-control form-control-sm mb-2"
                                  value={proj.technologies}
                                  onChange={(e) => updateProject(idx, 'technologies', e.target.value)}
                                  placeholder="Technologies"
                                />
                                <button 
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeProject(idx)}
                                >
                                  <FaTrash className="me-1" /> Remove
                                </button>
                              </>
                            ) : (
                              <>
                                <h3 className="project-name fw-bold mb-2" style={{ fontSize: '16px', color: '#1a1a1a' }}>
                                  {proj.name}
                                </h3>
                                <p style={{ fontSize: '14px', color: '#444', marginBottom: '8px', lineHeight: '1.7', textAlign: 'justify' }}>
                                  {proj.description}
                                </p>
                                <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
                                  <strong>Technologies:</strong> {proj.technologies}
                                </p>
                                {proj.link && (
                                  <p style={{ fontSize: '13px', color: '#0d6efd', margin: 0 }}>
                                    <FaGlobe className="me-1" />{proj.link}
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                        ))}
                      </div>

                      {/* Education */}
                      <div className="mb-4">
                        <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '20px', borderBottom: '3px solid #0d6efd', paddingBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          EDUCATION
                        </h2>
                        {resume.education.map((edu, idx) => (
                          <div key={idx}>
                            <h3 className="fw-bold mb-1" style={{ fontSize: '16px', color: '#1a1a1a' }}>
                              {edu.degree}
                            </h3>
                            <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
                              {edu.institution} | {edu.year} | GPA: {edu.gpa}
                            </p>
                          </div>
                        ))}
                      </div>

                      {/* Certifications */}
                      {resume.certifications.length > 0 && (
                        <div>
                          <h2 className="section-title text-primary fw-bold mb-3" style={{ fontSize: '20px', borderBottom: '3px solid #0d6efd', paddingBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            CERTIFICATIONS
                          </h2>
                          <ul style={{ paddingLeft: '22px', margin: 0 }}>
                            {resume.certifications.map((cert, idx) => (
                              <li key={idx} style={{ fontSize: '14px', color: '#444', marginBottom: '8px' }}>
                                <FaCertificate className="me-2 text-primary" />
                                {cert}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className="card shadow-sm border-0">
                  <div className="card-body text-center py-5">
                    <div className="mb-4">
                      <FaMagic size={80} className="text-primary mb-3" style={{ opacity: 0.7 }} />
                    </div>
                    <h4 className="text-muted mb-3">Ready to Create Your Perfect Resume?</h4>
                    <p className="text-muted mb-4">
                      Our AI-powered system will analyze the job description and create a tailored resume that highlights your relevant skills and experience.
                    </p>
                    <div className="row text-start">
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={20} />
                          <div>
                            <h6 className="fw-bold mb-1">Smart Keyword Matching</h6>
                            <small className="text-muted">Automatically extracts and includes relevant keywords from job descriptions</small>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={20} />
                          <div>
                            <h6 className="fw-bold mb-1">Role-Specific Content</h6>
                            <small className="text-muted">Generates tailored content based on your target role category</small>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={20} />
                          <div>
                            <h6 className="fw-bold mb-1">Quantified Achievements</h6>
                            <small className="text-muted">Includes metrics and measurable results to showcase impact</small>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={20} />
                          <div>
                            <h6 className="fw-bold mb-1">ATS-Friendly Format</h6>
                            <small className="text-muted">Optimized formatting that passes Applicant Tracking Systems</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ATS Checker Tab */}
        {activeTab === 'ats' && (
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body">
                  <h4 className="card-title fw-bold mb-3">
                    <FaCheckCircle className="me-2 text-success" />
                    ATS Compatibility Checker
                  </h4>
                  <p className="text-muted mb-4">
                    Analyze how well your resume matches a job description and get AI-powered optimization suggestions.
                  </p>
                  
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <FaFileDownload className="me-2 text-primary" />
                      Your Resume Text
                    </label>
                    <textarea
                      className="form-control"
                      rows="12"
                      placeholder="Paste your complete resume content here...

Include all sections:
• Contact information
• Professional summary
• Skills
• Work experience
• Projects
• Education
• Certifications"
                      value={atsResume}
                      onChange={(e) => setAtsResume(e.target.value)}
                      style={{ fontSize: '14px' }}
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <FaBriefcase className="me-2 text-primary" />
                      Job Description
                    </label>
                    <textarea
                      className="form-control"
                      rows="12"
                      placeholder="Paste the complete job description here...

Include all requirements:
• Required skills and technologies
• Years of experience
• Responsibilities
• Qualifications
• Nice-to-have skills"
                      value={atsJobDesc}
                      onChange={(e) => setAtsJobDesc(e.target.value)}
                      style={{ fontSize: '14px' }}
                    />
                  </div>
                  
                  <button 
                    className="btn btn-success w-100 py-3 fw-semibold"
                    onClick={analyzeATS}
                    disabled={isAnalyzing}
                  >
                    {isAnalyzing ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Analyzing Your Resume...
                      </>
                    ) : (
                      <>
                        <FaCheckCircle className="me-2" />
                        Analyze ATS Compatibility
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              {atsResult ? (
                <div className="card shadow-sm border-0">
                  <div className="card-body p-4">
                    <h4 className="card-title fw-bold mb-4">
                      <FaCheckCircle className="me-2 text-success" />
                      ATS Analysis Results
                    </h4>
                    
                    {/* Score Display */}
                    <div className="text-center mb-5 py-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                      <div 
                        className="d-inline-flex justify-content-center align-items-center rounded-circle shadow-lg mb-3"
                        style={{
                          width: '180px',
                          height: '180px',
                          background: atsResult.score >= 85 
                            ? 'linear-gradient(135deg, #28a745 0%, #20c997 100%)' 
                            : atsResult.score >= 70 
                              ? 'linear-gradient(135deg, #17a2b8 0%, #0d6efd 100%)' 
                              : atsResult.score >= 50 
                                ? 'linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)' 
                                : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                          color: 'white'
                        }}
                      >
                        <div>
                          <div style={{ fontSize: '56px', fontWeight: '700', lineHeight: '1' }}>
                            {atsResult.score}%
                          </div>
                          <div style={{ fontSize: '18px', fontWeight: '500', marginTop: '10px' }}>
                            ATS Score
                          </div>
                        </div>
                      </div>
                      
                      <div className="mt-3">
                        <span 
                          className={`badge px-4 py-2 ${
                            atsResult.score >= 85 ? 'bg-success' : 
                            atsResult.score >= 70 ? 'bg-info' :
                            atsResult.score >= 50 ? 'bg-warning text-dark' : 
                            'bg-danger'
                          }`}
                          style={{ fontSize: '15px', fontWeight: '600' }}
                        >
                          {atsResult.score >= 85 ? '🎉 Excellent - Highly Optimized' : 
                           atsResult.score >= 70 ? '✅ Good - Well Aligned' :
                           atsResult.score >= 50 ? '⚠️ Fair - Needs Optimization' : 
                           '❌ Poor - Requires Major Improvements'}
                        </span>
                      </div>

                      <div className="mt-3 px-3">
                        <div className="row text-center">
                          <div className="col-6">
                            <div className="p-2">
                              <h6 className="mb-1 text-success fw-bold">{atsResult.matchedKeywords.length}</h6>
                              <small className="text-muted">Matched Keywords</small>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="p-2">
                              <h6 className="mb-1 text-danger fw-bold">{atsResult.missingKeywords.length}</h6>
                              <small className="text-muted">Missing Keywords</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Matched Keywords */}
                    <div className="mb-4 p-3" style={{ backgroundColor: '#d1e7dd', borderRadius: '10px', border: '2px solid #badbcc' }}>
                      <h6 className="fw-bold text-success mb-3 d-flex align-items-center">
                        <FaCheckCircle className="me-2" size={20} />
                        Matched Keywords ({atsResult.matchedKeywords.length})
                      </h6>
                      {atsResult.matchedKeywords.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2">
                          {atsResult.matchedKeywords.map((kw, idx) => (
                            <span 
                              key={idx} 
                              className="badge bg-success px-3 py-2"
                              style={{ fontSize: '13px', fontWeight: '500' }}
                            >
                              ✓ {kw}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted mb-0 small">No matching keywords found. Add relevant skills from the job description.</p>
                      )}
                    </div>

                    {/* Missing Keywords */}
                    <div className="mb-4 p-3" style={{ backgroundColor: '#f8d7da', borderRadius: '10px', border: '2px solid #f5c2c7' }}>
                      <h6 className="fw-bold text-danger mb-3 d-flex align-items-center">
                        <FaTimes className="me-2" size={20} />
                        Missing Critical Keywords ({atsResult.missingKeywords.length})
                      </h6>
                      {atsResult.missingKeywords.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2">
                          {atsResult.missingKeywords.map((kw, idx) => (
                            <span 
                              key={idx} 
                              className="badge bg-danger px-3 py-2"
                              style={{ fontSize: '13px', fontWeight: '500' }}
                            >
                              ✗ {kw}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted mb-0 small">Excellent! All important keywords are present in your resume.</p>
                      )}
                    </div>

                    {/* AI Suggestions */}
                    <div className="p-3" style={{ backgroundColor: '#cfe2ff', borderRadius: '10px', border: '2px solid #b6d4fe' }}>
                      <h6 className="fw-bold text-primary mb-3 d-flex align-items-center">
                        <FaLightbulb className="me-2" size={20} />
                        AI-Powered Optimization Tips
                      </h6>
                      <div className="suggestions-list">
                        {atsResult.suggestions.map((suggestion, idx) => (
                          <div key={idx} className="mb-2 p-2 bg-white rounded" style={{ border: '1px solid #e9ecef' }}>
                            <small style={{ fontSize: '13px', color: '#004085', lineHeight: '1.6', display: 'block' }}>
                              {suggestion}
                            </small>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="mt-4 d-grid gap-2">
                      <button 
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setAtsResult(null);
                          setAtsResume('');
                          setAtsJobDesc('');
                        }}
                      >
                        <FaTools className="me-2" />
                        Check Another Resume
                      </button>
                      <button 
                        className="btn btn-outline-success"
                        onClick={() => {
                          setActiveTab('generator');
                          setJobDescription(atsJobDesc);
                        }}
                      >
                        <FaMagic className="me-2" />
                        Generate Optimized Resume
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card shadow-sm border-0">
                  <div className="card-body text-center py-5">
                    <div 
                      className="d-inline-flex justify-content-center align-items-center rounded-circle mb-4"
                      style={{
                        width: '120px',
                        height: '120px',
                        backgroundColor: '#e9ecef'
                      }}
                    >
                      <FaCheckCircle size={60} className="text-muted" />
                    </div>
                    <h5 className="text-muted mb-3">Ready to Check Your ATS Score?</h5>
                    <p className="text-muted mb-4">
                      Our advanced ATS checker analyzes your resume against job requirements and provides detailed optimization suggestions.
                    </p>
                    <div className="row text-start">
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={18} />
                          <div>
                            <h6 className="fw-bold mb-1 small">Keyword Analysis</h6>
                            <small className="text-muted">Identifies matched and missing keywords</small>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={18} />
                          <div>
                            <h6 className="fw-bold mb-1 small">Compatibility Score</h6>
                            <small className="text-muted">Overall ATS match percentage</small>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={18} />
                          <div>
                            <h6 className="fw-bold mb-1 small">Smart Suggestions</h6>
                            <small className="text-muted">AI-powered optimization tips</small>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="d-flex align-items-start">
                          <FaCheckCircle className="text-success me-3 mt-1" size={18} />
                          <div>
                            <h6 className="fw-bold mb-1 small">Instant Results</h6>
                            <small className="text-muted">Get feedback in seconds</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Custom Styles */}
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .card-body[ref] * {
            visibility: visible;
          }
          .card-body[ref] {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        
        .form-control:focus {
          border-color: #0d6efd;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
        }
        
        .btn {
          transition: all 0.3s ease;
        }
        
        .btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        
        .card {
          transition: all 0.3s ease;
          border-radius: 12px;
        }
        
        .badge {
          transition: all 0.2s ease;
        }
        
        .navbar {
          backdrop-filter: blur(10px);
        }
        
        .section-title {
          letter-spacing: 0.5px;
        }
        
        .experience-item:last-child {
          margin-bottom: 0 !important;
        }
        
        .project-item:last-child {
          margin-bottom: 0 !important;
        }
        
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }

        .suggestions-list {
          max-height: 400px;
          overflow-y: auto;
        }

        .sticky-top {
          position: sticky;
          top: 20px;
          z-index: 100;
        }

        @media (max-width: 991px) {
          .sticky-top {
            position: relative;
            top: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ResumeBuilder;